import React, { FC } from 'react';

import styles from './DropDownMenu.module.scss';

export type DropdownMenuItemStyle = {
  '--menuBorder'?: string;
  '--menuBg'?: string;
  '--menuTop'?: string;
  '--menuPadding'?: string;
  '--sectionSeparator'?: string;
  '--menuBorderRadius'?: string;
};

type DropDownMenuProps = {
  variant?: 'bubble' | 'filter' | 'plain' | 'lined' | 'multi' | 'outlined' | `multiFilter`;
  isVisible: boolean;
  position?: 'left' | 'right' | 'center';
  maxHeight?: string;
  width?: string;
  header?: boolean;
  topPosition?: string;
  children?: React.ReactNode;
  style?: DropdownMenuItemStyle;
};

const DropDownMenu: FC<DropDownMenuProps> = ({
  variant = '',
  isVisible = false,
  header = true,
  position = 'right',
  maxHeight,
  topPosition,
  width,
  children,
  style,
}) => {
  const arrayChildren = React.Children.toArray(children);

  return (
    <nav
      style={{
        maxHeight,
        width,
        top: topPosition !== '' && (variant === 'multi' || variant === 'multiFilter') ? topPosition : 'inherited',
        ...style,
      }}
      className={[
        styles['drop-down-menu'],
        styles[variant],
        styles[getMenuVisibilityClass()],
        styles[getPositionClass()],
        styles[getScrollClass()],
        styles[getHeaderClass()],
        'scrollbar',
      ].join(' ')}
    >
      {arrayChildren.map((child, idx) => (
        <div key={`drop-=down-menu-section-${idx}`} className={[styles.arrow, styles[getSectionClass(idx)]].join(' ')}>
          {child}
        </div>
      ))}
    </nav>
  );

  function getMenuVisibilityClass() {
    return isVisible ? 'visible' : 'hidden';
  }

  function getPositionClass() {
    return `position-${position}`;
  }

  function getSectionClass(idx: number) {
    return idx === 0 ? '' : 'section';
  }

  function getScrollClass() {
    return maxHeight !== '' ? 'scroll' : '';
  }
  function getHeaderClass() {
    return header ? '' : 'noHeader';
  }
};

export default DropDownMenu;
